export class MailingAddress {
  public AccountId?: string;
  public PersonId?: string;
  public AddressLine1?: string;
  public AddressSource?: string;
  public AddressLine2?: string;
  public City?: string;
  public State?: string;
  public Postal?: string;
  public Country?: string;
}
